// extracted by mini-css-extract-plugin
export var label = "_4e-1";
export var reminder = "_4e-0";